import { render } from "./teams.vue?vue&type=template&id=8a5e243a&scoped=true&ts=true"
import script from "./teams.ts?vue&type=script&lang=ts&external"
export * from "./teams.ts?vue&type=script&lang=ts&external"

import "./teams.scss?vue&type=style&index=0&id=8a5e243a&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a5e243a"]])

export default __exports__